<p-dialog [header]="dialogHeader" [(visible)]="display" (onHide)="onDialogClose()" [modal]="true" [responsive]="true"
    [style]="{width: '75vw'}">
    <div class="header">
        <h5>Template Information
            <p-inputSwitch class="header-switch" [(ngModel)]="isActive" [disabled]="isView"></p-inputSwitch>
        </h5>
    </div>
    <form class="card" [formGroup]="emailDetailsForm">

        <div class="p-grid">
            <div class="p-col-9">
                <div class="p-grid">
                    <div class="p-col-12">
                        <label>Channel <span style="color: red;">*</span></label>
                        <p-dropdown appendTo="body" formControlName="selectedChannel" optionLabel="name" dataKey="id"
                            placeholder="Select Channel" [filter]="true" [resetFilterOnHide]="true"
                            [options]="channelNames" (onChange)="selectChannel($event)" [disabled]="isView">
                        </p-dropdown>

                        <div *ngIf="detailsFormErrors?.selectedChannel" class="p-invalid">
                            <small>{{ detailsFormErrors?.selectedChannel }}</small>
                        </div>
                    </div>
                </div>
                <div class="p-grid">
                    <div class="p-col-12">
                        <label>Template Name <span style="color: red;">*</span></label>
                        <input type="text" pInputText placeholder="Enter Name" formControlName="templateName">

                        <div *ngIf="detailsFormErrors?.templateName" class="p-invalid">
                            <small>{{ detailsFormErrors?.templateName }}</small>
                        </div>
                    </div>
                </div>

                <!-- <div class="p-grid">
                    <div class="p-col-6">
                        <label>Notification Type <span style="color: red;">*</span></label>
                        <p-dropdown appendTo="body" formControlName="notificationType" optionLabel="name" dataKey="id"
                            placeholder="Select notificaiton type" [filter]="true" [resetFilterOnHide]="true"
                            [options]="emailTemplateNotificationTypes" (onChange)="changeNotificationType()" [disabled]="isView">
                        </p-dropdown>

                        <div *ngIf="detailsFormErrors?.notificationType" class="p-invalid">
                            <small>{{ detailsFormErrors?.notificationType }}</small>
                        </div>
                    </div>

                    <div class="p-col-6">
                        <label>Action Type <span style="color: red;">*</span></label>
                        <p-dropdown appendTo="body" formControlName="actionType" optionLabel="name" dataKey="id"
                            placeholder="Select action type" [filter]="true" [resetFilterOnHide]="true"
                            [options]="emailTemplateActionTypes" [disabled]="isView">
                        </p-dropdown>

                        <div *ngIf="detailsFormErrors?.actionType" class="p-invalid">
                            <small>{{ detailsFormErrors?.actionType }}</small>
                        </div>
                    </div>
                </div> -->
            </div>

            <div class="p-col-3">
                <div class="p-d-flex align-items-center p-mt-5">
                    <p-checkbox name="isDefault" value="true" [binary]="true" formControlName="isDefault"
                        inputId="isDefault" [disabled]="isView"></p-checkbox>
                    <label for="isDefault" class="p-ml-2">Make Default Template</label>
                </div>

                <div class="p-d-flex align-items-center p-mt-6">
                    <p-checkbox name="isEditable" value="true" [binary]="true" formControlName="isEditable"
                        inputId="isEditable" [disabled]="isView"></p-checkbox>
                    <label for="isEditable" class="p-ml-2">Editable Template</label>
                </div>

                <!-- <div class="p-d-flex align-items-center p-mt-1">
                    <p-checkbox name="isEnclosureRequired" value="true" [binary]="true" formControlName="isEnclosureRequired" inputId="isEnclosureRequired" [disabled]="isView"></p-checkbox>
                    <label for="isEnclosureRequired" class="p-ml-2">Attach Details</label>
                </div> -->
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-9" [ngClass]="{'p-col-12': isView, 'p-col-9': !isView}">
                <div *ngIf="emailDetailsForm.value.notificationType?.id==notificationTypeEnum.Email" class="p-grid">
                    <div class="p-col-12">
                        <label>Notification Subject <span style="color: red;">*</span></label>
                        <input type="text" (focus)="selectedInsertField='templateSubject'" (click)="selectedInsertField='templateSubject'" pInputText
                            placeholder="Enter Subject" formControlName="templateSubject">

                        <div *ngIf="detailsFormErrors?.templateSubject" class="p-invalid">
                            <small>{{ detailsFormErrors?.templateSubject }} {{ emailDetailsForm.get('templateSubject')?.errors?.invalidTags }}</small>
                        </div>
                    </div>
                </div>
                <div class="p-grid">
                    <div class="p-col-12">
                        <div class="p-d-flex p-mb-1">
                            <label>
                                {{ emailDetailsForm.value.notificationType?.id==notificationTypeEnum.Email ?
                                'Notification Body' : 'Message Content' }} <span style="color: red;">*</span>
                            </label>
                            <div class="p-d-flex align-items-center p-ml-auto">
                                <p-checkbox name="isHtmlBody" value="true" [binary]="true" formControlName="isHtmlBody"
                                    inputId="enclosure"
                                    [disabled]="(emailDetailsForm.value.notificationType?.id!==notificationTypeEnum.Email) || isView"></p-checkbox>
                                <label for="enclosure" class="p-ml-2">Allow HTML</label>
                            </div>
                        </div>

                        <textarea *ngIf="!emailDetailsForm.value.isHtmlBody" #templateBodyArea [readonly]="isView"
                            (click)="setBodyCursorPosition(templateBodyArea)"
                            (keyup)="setBodyCursorPosition(templateBodyArea)" rows="19" formControlName="templateBody"
                            pInputText placeholder="Add your message..."></textarea>

                        <!-- <p-editor *ngIf="emailDetailsForm.value.isHtmlBody" #editor (onSelectionChange)="selectedInsertField='templateBody'"
                            placeholder="Add your message..." [style]="{'height':'220px'}"
                            formControlName="templateBody" [readonly]="isView"></p-editor> -->

                        <p-editor *ngIf="emailDetailsForm.value.isHtmlBody" #editor
                            (onTextChange)="onEditorTextChange($event)" [modules]="editorModules"
                            (onSelectionChange)="selectedInsertField='templateBody'"
                            styleClass="email-template-editor" [(ngModel)]="notificationBody"
                            [ngModelOptions]="{standalone: true}" [readonly]="isView">
                            <p-header>
                                <span class="ql-formats">
                                    <select class="ql-size">
                                        <option value="small">small</option>
                                        <option selected></option>
                                        <option value="large">large</option>
                                        <option value="huge">huge</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <select class="ql-size">
                                        <option value="24px">24</option>
                                        <option value="48px">48</option>
                                        <option value="100px">100</option>
                                        <option value="200px">200</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-bold" aria-label="Bold"></button>
                                    <button class="ql-italic" aria-label="Italic"></button>
                                    <button class="ql-underline" aria-label="Underline"></button>
                                    <button class="ql-strike" aria-label="Strike"></button>
                                </span>
                                <span class="ql-formats">
                                    <select title="Text Color" class="ql-color"></select>
                                    <span class="ql-format-separator"></span>
                                    <select title="Background Color" class="ql-background"></select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" value="ordered"></button>
                                    <button class="ql-list" value="bullet"></button>
                                    <select title="Text Alignment" class="ql-align">
                                        <option selected>Gauche</option>
                                        <option value="center" label="Center"></option>
                                        <option value="right" label="Right"></option>
                                        <option value="justify" label="Justify"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button aria-label="Link" class="ql-link"></button>
                                    <button aria-label="Image" class="ql-image"></button>
                                    <button class="pi pi-table" title="Insert Table" (click)="insertTable()"></button>
                                    <span class="btnBars ai-custom" (click)="activityItems.toggle($event)">
                                        <i class="pi ql-ai" [style.background-image]="'url(' + defaultAIImage + ')'"></i>
                                    </span>
                                    <p-overlayPanel #activityItems styleClass="activityItems custom-ai">
                                        <ng-template pTemplate>
                                          <ul>
                                            <li (click)="showGenerateEmailDialog();activityItems.hide($event)" icon="pi pi-external-link">
                                              <span><i class="pi pi-envelope p-mr-2"></i>Generate Email</span>
                                            </li>
                                          </ul>
                                        </ng-template>
                                    </p-overlayPanel>
                                </span>
                            </p-header>
                        </p-editor>

                        <div *ngIf="detailsFormErrors?.templateBody" class="p-invalid">
                            <small>{{ detailsFormErrors?.templateBody }} {{ emailDetailsForm.get('templateBody')?.errors?.invalidTags }}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isView" class="p-col-3">
                <label>Available Fields</label>
                <p-listbox [options]="fieldTypesByGroup" [group]="true" [metaKeySelection]="false" [(ngModel)]="selectedField" [ngModelOptions]="{standalone: true}"
                    optionLabel="name" (onChange)="selectTemplateField($event)" [filter]="true"
                    class="available-field-list"
                    [listStyle]="{'max-height': emailDetailsForm.value.notificationType?.id==notificationTypeEnum.Email ? '303px' : '227px'}">
                    <ng-template let-group pTemplate="group">
                        <div class="listbox-group">
                          <h6 class="p-py-2 p-px-3 p-mb-0">{{group.label}}</h6>
                        </div>
                    </ng-template>
                    <ng-template let-type pTemplate="item">
                        <div class="type-item" [ngClass]="{'type-item-added': addedFieldTags.includes(type.name), 'type-group-item': type?.childGroup, 'type-child-item': type?.childItem}">
                            <div>{{type.name}}</div>
                        </div>
                    </ng-template>
                </p-listbox>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12">
                <label>Add Attachments
                    <i  class="pi pi-exclamation-circle"
                            [escape]="false" [pTooltip]="multiLineTooltip"
                            tooltipPosition="top"></i>
                </label>

                <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose Files" [multiple]="true" [showUploadButton]="false" [showCancelButton]="false" [disabled]="isView"
                    (onSelect)="uploadAttachments($event.files)">
                    <ng-template pTemplate="file"></ng-template>
                    <ng-template pTemplate="content">
                        <ng-container *ngFor="let attachmentDetails of attachments;let i=index;">
                            <ng-container *ngIf="attachmentDetails.statusId === 1">
                                <div class="p-fileupload-row">
                                    <button type="button" pButton icon="fa fa-download"
                                        (click)="downloadFile(attachmentDetails.displayFileName, attachmentDetails?.attachment?.content, attachmentDetails?.attachment?.id)"
                                        class="p-button-link p-px-0 p-py-0" label="">
                                    </button>
                                    <div [ngClass]="{'p-fileupload-link': !!(attachmentDetails?.attachment?.id>0)}">
                                        <ng-container *ngIf="attachmentDetails.displayFileName.length>50 else splitImageName">
                                            <div (click)="openFileNewTab(attachmentDetails?.attachment)">{{ attachmentDetails.displayFileName.substring(0, 50) }}...</div>
                                        </ng-container>
                                        <ng-template #splitImageName>
                                            <div (click)="openFileNewTab(attachmentDetails?.attachment)">{{ attachmentDetails.displayFileName }}</div>
                                        </ng-template>
                                    </div>

                                    <div style="width: 100px; max-width: 100px;">{{ (attachmentDetails.fileSize / 1024).toFixed(2) + ' KB' }}</div>
                                    <div style="width: 60px; max-width: 60px;" *ngIf="!isView">
                                        <button icon="pi pi-times" pButton (click)="removeAttachment(attachmentDetails,i)" type="button" icon="pi pi-times"></button>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!isView" type="button" pButton (click)="saveNotificationTemplate()" label="Save"></button>
    </p-footer>
</p-dialog>

<!-- File Opener Modal -->
<app-shared-file-opener
    *ngIf="displayFilePreview"
    [directLink]="true"
    [modalDisplay]="displayFilePreview"
    [modalFile]="currentFile"
    (closeFilePreview)="closeFilePreview()">
</app-shared-file-opener>

<app-email-generate-ai *ngIf="visibleEmailGenerationScenario"
    [displayDialog]="visibleEmailGenerationScenario"
    (emailGenerated)="setGeneratedEmail($event)"
    (dialogClose)="closeGenerateDialog()">
</app-email-generate-ai>
